<template>
  <div id="app">
    <!-- <transition :name="transitionName"> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
        <!-- 这里是会被缓存的视图组件，比如 Home！ -->
      </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive">
      <!-- 这里是不会被缓存的视图组件，比如 Profile！ -->
    </router-view>
    <!--  </transition> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      transitionName: "slide-left",
      isRouterAlive: true,
      show: true,
    };
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  created() {
    this.token();
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    token() {
      // let token = "Bearer c0abab76-b438-462b-8dcf-8352e4511183";
      // let accountUid = "09a7105c235c783270e717e0e9272fc0";
      // let key = "ACCOUNT_IDENTITY_TYPE_DRIVER";
      // let identify = "driver";
      // let orderSn = "";
      // let type = "android";
      let token ="Bearer "+this.$Request.token
      let accountUid=this.$Request.id
      let key =this.$Request.key
      let identify = this.$Request.identify
      let orderSn = this.$Request.orderSn
      let type = this.$Request.type
      // 把拿到的token存到本地
      localStorage.setItem("token", token);
      localStorage.setItem("accountUid", accountUid);
      localStorage.setItem("key", key);
      localStorage.setItem("identify", identify);
      localStorage.setItem("orderSn", orderSn);
      localStorage.setItem("type", type);
    },
  },
  watch: {
    $route(to, from) {
      this.transitionName =
        to.meta.index < from.meta.index ? "slide-right" : "slide-left";
    },
  },
};
</script>
<style lang="less">
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: absolute;
}
.van-cell {
  // line-height: 0.5rem !important;
}
// .van-icon__image{
// 	width: 30px !important;
// 	height: 30px !important;
// }
.slide-right-enter {
  /*opacity: 0;*/
  transform: translate3d(-100%, 0, 0);
}

.slide-right-leave-active {
  /*opacity: 0;*/
  transform: translate3d(100%, 0, 0);
}

.slide-left-enter {
  /*opacity: 0;*/
  transform: translate3d(100%, 0, 0);
}

.slide-left-leave-active {
  /*opacity: 0;*/
  transform: translate3d(-100%, 0, 0);
}

#app {
  width: 100%;
  height: 100%;
}

* {
  box-sizing: border-box;
}
html,
body,
div,
ul,
li,
h1,
h2,
h3,
h4,
h5,
h6,
p,
dl,
dt,
dd,
ol,
form,
input,
textarea,
th,
td,
select {
  margin: 0;
  padding: 0;
}
* {
  box-sizing: border-box;
}
html,
body {
  min-height: 100%;
}

body {
  font-family: "Microsoft YaHei";
  font-size: 14px;
  color: #333;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: normal;
}
ul,
ol {
  list-style: none;
}

img {
  border: none;
  vertical-align: middle;
}

a {
  text-decoration: none;
  color: #232323;
}

table {
  border-collapse: collapse;
  table-layout: fixed;
}

input,
textarea {
  outline: none;
  border: none;
}

textarea {
  resize: none;
  overflow: auto;
}

.clearfix {
  zoom: 1;
}

.clearfix:after {
  content: ".";
  width: 0;
  height: 0;
  visibility: hidden;
  display: block;
  clear: both;
  overflow: hidden;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.tl {
  text-align: left;
}

.tc {
  text-align: center;
}

.tr {
  text-align: right;
}

.ellipse {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.inline {
  display: inline-block;
  *display: inline;
  *zoom: 1;
}
</style>
